import { DEFAULT_TRACK_ENDPOINT, DefaultLogger, SafeShell } from '../../core';
import type { TrackPlugin, TrackEvent } from '../../core';
import { createPayloadFormatter } from './payload-formatter';
import type { LegacyParameters } from './parameter-types';

export interface LegacyWebtrackOptions {
  endpoint?: string;
  /** 初始化时固定参数配置；省略时保持旧版字段预设。 */
  parameters?: LegacyParameters;
}

export interface LegacyPluginInstance extends TrackPlugin {
  isSuccessResponse(res: { status: number; data: any }): boolean;
  formatPayload(event: TrackEvent): string;
}

/**
 * 海典旧版埋点协议适配插件工厂
 */
export function legacyWebtrackPlugin(options?: LegacyWebtrackOptions): LegacyPluginInstance {
  // 公开工厂也可能被独立调用；配置 getter 异常不能绕过宿主安全边界。
  options = new SafeShell(new DefaultLogger()).run<LegacyWebtrackOptions>(
    () => ({ ...options }), { parameters: { mode: 'configured' } }, 'Legacy.options'
  );
  const formatPayload = createPayloadFormatter(options?.parameters);
  let endpoint = options?.endpoint;
  let request: ((
    url: string,
    data: string | Record<string, unknown>,
    headers?: Record<string, string>
  ) => Promise<{ status: number; data: any }>) | undefined;

  const isSuccessResponse = (res: { status: number; data: any }): boolean => {
    if (!res || res.status !== 200) return false;
    const code = res.data?.code;
    return code === '10000' || code === 10000;
  };

  return {
    name: 'hss-legacy-webtrack-plugin',

    init(tracker: any) {
      if (typeof tracker.request === 'function') {
        request = tracker.request.bind(tracker);
      }
      endpoint = endpoint ?? tracker.getEndpoint?.() ?? DEFAULT_TRACK_ENDPOINT;
    },

    formatPayload(event: TrackEvent): string {
      return formatPayload(event);
    },

    isSuccessResponse(res: { status: number; data: any }): boolean {
      return isSuccessResponse(res);
    },

    async send(event: TrackEvent): Promise<boolean> {
      if (!request) return false;
      const payload = formatPayload(event);
      if (!payload) return false;
      const response = await request(
        endpoint ?? DEFAULT_TRACK_ENDPOINT,
        payload,
        { 'Content-Type': 'application/x-www-form-urlencoded' }
      );
      return isSuccessResponse(response);
    },

  };
}
